import { SET_ART_WALL_PRODUCTS_TO_BE_SHARED } from './../const';

export default (artWallProductsToBeShared) => {
  return {
    type: SET_ART_WALL_PRODUCTS_TO_BE_SHARED,
    artWallProductsToBeShared: artWallProductsToBeShared
  }
};
